export default "__VITE_ASSET__04d21842__"